import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  text: string;
}

const EsrrBadge: React.FC<Props> = ({ text }) => {
  const { t } = useTranslation();
  const values = ['1Low', '2Moderate', '3Substantial', '4High'];

  const textInValues = values.includes(text);
  const getClass = (compare: string) => (text > compare ? text.substr(1) : '');

  return textInValues ? (
    <div className="badge-base">
      <div className="badge-bargroup esrr">
        <div className={`badge-bar ${getClass('1')}`} />
        <div className={`badge-bar ${getClass('2')}`} />
        <div className={`badge-bar ${getClass('3')}`} />
        <div className={`badge-bar ${getClass('4')}`} />
        <div className="badge-text">
          <span>{t(`esrrCodes.${text}`)}</span>
        </div>
      </div>
    </div>
  ) : (
    text
  );
};

export default React.memo(EsrrBadge);
